import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

export const PERFORMER_ADD_HELP_STEPS = [
  'Using the X in the top right, close this modal and save any changes to your event.',
  'In the navigation menu, click Event Management, then select My Performers.',
  'Click Add Performer.',
  'Complete the performer information and click Save Performer.',
  'Return to your event.',
  'Locate the Performers table for the appropriate stage and click Add Performer.',
  'Select the performer you just created.',
  'Enter the performance day and time.',
  'Click Save to add the performer to the event schedule.',
];

export const VENDOR_ADD_HELP_STEPS = [
  'Save any changes to your event.',
  'In the navigation menu, click Event Management, then select My Vendors.',
  'Click Add Vendor.',
  'Complete the vendor information and click Save Vendor.',
  'Return to your event.',
  'Locate the Vendors table and click Add Vendor.',
  'Select the vendor you just created.',
  'Complete any required event-specific information.',
  'Click Save to add the vendor to your event.',
];

/**
 * Helper line + instructional view for selecting library performers/vendors.
 * @param {{ entityNoun: 'performer' | 'vendor', steps: string[], showHelp: boolean, onShowHelp: () => void, onBack: () => void }} props
 */
export function ModalEntityHelp({
  entityNoun,
  steps,
  showHelp,
  onShowHelp,
  onBack,
}) {
  if (showHelp) {
    return (
      <div>
        <ol className="m-0 list-decimal space-y-3 pl-5 text-sm leading-relaxed text-[#121212]">
          {steps.map((step) => (
            <li key={step}>{step}</li>
          ))}
        </ol>
        <button
          type="button"
          className="mt-8 inline-flex min-h-11 items-center justify-center rounded-[var(--bethere-radius-md)] border-2 border-primary bg-transparent px-5 font-bold text-primary transition-all hover:-translate-y-px hover:bg-primary hover:text-primary-foreground"
          onClick={onBack}
        >
          Back
        </button>
      </div>
    );
  }

  return (
    <p className="mb-6 flex flex-wrap items-center gap-1.5 text-sm leading-relaxed text-[var(--muted-foreground)]">
      <button
        type="button"
        className="inline-flex items-center justify-center border-none bg-transparent p-0 text-[var(--muted-foreground)] transition-colors hover:text-neutral-700"
        onClick={onShowHelp}
        aria-label={`How to add a ${entityNoun}`}
      >
        <FontAwesomeIcon icon={['fas', 'circle-info']} />
      </button>
      <span>I don&apos;t see my {entityNoun} in the list.</span>
    </p>
  );
}
